import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    capitalize: {
      textTransform: 'capitalize',
    },

    textRight: {
      textAlign: 'right',
    },

    time: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(12),
    },

    date: {
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightMedium,
    },
    cell: {
      padding: '8px 0',
      borderColor: '#E0E0E0',
    },
    borderNone: {
      border: '0px',
    },
  };
});

const collapseCardStyles = makeStyles({
  root: {
    marginTop: 0,
    marginBottom: 16,
    '& button': {
      borderRadius: '4px 4px 0 0',
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
    padding: '16px 24px',
  },
  buttonClass: {
    backgroundColor: '#FBFBFB',
    border: '1px solid #EEEEEE',
    boxShadow: 'none',
    color: '#4D4F5C',
    padding: '6px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EEEEEE',
      boxShadow: 'none',
      color: '#4D4F5C',
    },
  },
});

export { useStyles, collapseCardStyles };
